import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import TextInput from "../ui/textInput";
import {changeCartFeature} from "../../actions/actionFunctions";

class PriceInput extends React.Component {

  static propTypes = {
    cartItem: PropTypes.object.isRequired,
    priceTotal: PropTypes.number
  };

  handlePriceOnChange = (amount) => {
    this.setPrice(amount)
  };

  setPrice = (amount) => {
    const cartItem = this.props.cartItem;
    const newAmount = Math.trunc((amount / cartItem.quantity) * 100) / 100;
    cartItem.cartFeature.dbFeature.cost = newAmount;
    cartItem.cartFeature.dbFeature.fabricatorCost = newAmount;
    this.props.changeCartFeature(cartItem);
  };

  render() {
    const {priceTotal} = this.props;
    return <TextInput className={"price-input"}
                      numberInput={true}
                      onChange={this.handlePriceOnChange}
                      value={priceTotal}/>
  }
}


const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  changeCartFeature
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PriceInput)
)
